
namespace GeniuzPOS.PosShift {
    import fld = PsTaxInvoiceHdRow.Fields
    @Serenity.Decorators.registerClass()
    export class PsTaxInvoiceHdGrid extends Serenity.EntityGrid<PsTaxInvoiceHdRow, any> {
        protected getColumnsKey() { return PsTaxInvoiceHdColumns.columnsKey; }
        protected getDialogType() { return PsTaxInvoiceHdDialog; }
        protected getIdProperty() { return PsTaxInvoiceHdRow.idProperty; }
        protected getInsertPermission() { return PsTaxInvoiceHdRow.insertPermission; }
        protected getLocalTextPrefix() { return PsTaxInvoiceHdRow.localTextPrefix; }
        protected getService() { return PsTaxInvoiceHdService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }



        protected getColumns() {
            var columns = super.getColumns();

            // var item = this.itemAt(row);
            // if()

            columns.splice(4, 0, {
                id: 'Print PsTaxInvoiceprint',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-PsTaxInvoiceprint" title="PsTaxInvoiceprint">' +
                        '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });

            return columns;
        }
       

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            // if (e.isDefaultPrevented())
            //     return;

            var item = this.itemAt(row);
            var target = $(e.target);


            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('print-PsTaxInvoiceprint')) {
                    this.view.getRows()
                    const request: PsTaxInvoicePrintData = {} as any;
                    request.DocNo = item.DocNo
                    // request.Details = PsTaxInvoiceDtRow.getLookup().items.filter(x => x.DocNo == item.DocNo)
                    // console.log(PsTaxInvoiceDtRow.getLookup().items.filter(x => x.DocNo == item.DocNo))
                    
                    // var id = PosShift.PsTaxInvoiceHdRow.getLookup().itemById[item.DocNo];
                    // //const toDay = new Date();
                    // id.NoOfPrint += 1;
                    // // id.ConfirmFlg = ConfirmFlg.Confirm;
                    // PosShift.PsTaxInvoiceHdService.Update({Entity: id},(q) => { this.refresh() });
                    
                    // console.log(item.DocNo + "<< DocNo")
                    // request.Header = Q.tryFirst(PsTaxInvoiceHdRow.getLookup().items, x => x.DocNo == item.DocNo)

                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    if (fg != null) {
                        let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == item.ShopId)
                        request.BizName = s.ShopRegName
                        request.BizAddressLine1 = s.ShopRegAddressLine1
                        request.BizAddressLine2 = s.ShopRegAddressLine2
                        request.BizAddressLine3 = s.ShopRegAddressLine3
                        request.TaxId = s.ShopTaxId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                        request.BizName = q.BizName
                        request.BizAddressLine1 = q.TaxInvAddrLine1
                        request.BizAddressLine2 = q.TaxInvAddrLine2
                        request.BizAddressLine3 = q.TaxInvAddrLine3
                        request.TaxId = q.BizName
                    }

                    let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)
                    let sss = p.ShopLogoOnFrontScreen
                    if (!Q.isEmptyOrNull(sss)) {
                        let vp = window.location.href.replace("#", "")
                        console.log(vp)
                        let ap = vp.replace("/PosShift/PsTaxInvoiceHd", "")
                        request.URLpic = ap + "/upload/" + p.ShopLogoOnFrontScreen
                        
                    } else {
                        request.URLpic = "SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png

                    }
                    console.log(request.URLpic)
                    let doc = item.DocType
                    let vat = item.SalesVatType;

                    if(doc == 1){
                        if (vat == "E") {
                            request.Type = 2
                        } else {
                            request.Type = 1
                        }
                    }else{
                        if (vat == "E") {
                            request.Type = 4
                        } else {
                            request.Type = 3
                        }
                    }
                    




                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                        // }else{
                        //     Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                        // }

                        ;
                }

                if (target.hasClass("editlink")) {

                    if(item.DocType == 1){
                        new PsTaxInvoiceHdDialog().loadByIdAndOpenDialog(item.DocNo);
                    }else{
                        new PsTaxInvoiceHd2Dialog().loadByIdAndOpenDialog(item.DocNo);
                    }
                    

                   

                }

            }
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate() - 13));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

           
            return filters;
        }



        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            let send: Serenity.ToolButton =(
                {
                    title: Q.text("New ใบลดหนี้"), // *** Get button text from translation
                    cssClass: 'add-',
                    icon: 'fa fa-plus-circle text-green',
                    onClick: () => {
                        window.location.href = '/PosShift/PsTaxInvoiceHd#PosShift.PsTaxInvoiceHd2/new';

                    },

                }
            );
            buttons.push(send);


            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsTaxInvoiceHdService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            




            buttons.push(
                {
                    title: Q.text("รายงานรายวันออกใบกำกับภาษี"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o text-red',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                        const request: PsTaxInvoiceListData = {} as any;
                       
                        request.Header = this.view.getRows();
                        
                        let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                        if (fg != null) {
                            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                            let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == userId.ShopId)
                            request.BizName = s.ShopRegName
                            request.BizAddressLine1 = s.ShopRegAddressLine1
                            request.BizAddressLine2 = s.ShopRegAddressLine2
                            request.BizAddressLine3 = s.ShopRegAddressLine3
                            request.TaxId = s.ShopTaxId
                        } else {
    
                            let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                            request.BizName = q.BizName
                            request.BizAddressLine1 = q.TaxInvAddrLine1
                            request.BizAddressLine2 = q.TaxInvAddrLine2
                            request.BizAddressLine3 = q.TaxInvAddrLine3
                            request.TaxId = q.TaxId
                        }

                        let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)
                        let sss = p.ShopLogoOnFrontScreen
                        if (!Q.isEmptyOrNull(sss)) {
                            let vp = window.location.href.replace("#", "").replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/PosShift/PsTaxInvoiceHd", "")
                            request.URLpic = ap + "/upload/" + p.ShopLogoOnFrontScreen
                        } else {
                            request.URLpic = "SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png


                        }
                            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                            request.Shop = userId.ShopId;

                        
                        if (request?.Criteria) {
                            
                            let criteria = request.Criteria.toString().split(',');
                            let key: string = criteria[0];
                                     
            
                            let d1 = criteria.findIndex(c => c == ">=");
                            if (d1 >= 0) {
                                let v1 = criteria[d1 + 1];
                                let d2 = criteria.findIndex(c => c == "<");
                                
                                if (d2 >= 0) {
                                    let v2 = criteria[d2 + 1];
                                    
                                    request.DatetoDate = (`${key}  ${Q.formatDate(v1, "dd/MM/yyyy"+' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy"+' (00:00)')}`);
            
                                } else {
                                    request.DatetoDate = (`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
                                }
                            } else {
                                let d2 = criteria.findIndex(c => c == "<");
                                if (d2 >= 0) {
                                    let v2 = criteria[d2 + 1];
                                    request.DatetoDate = (`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
                                }
                            }
                        } else {
                            request.DatetoDate = "วันที่ = ไม่ระบุ";
                        }
                        



                        Q.postToService({ service: this.getService() + '/ExportPdfdaily', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber

                    },

                }
            );


            // import { ReportHelper } from "@serenity-is/extensions";

            // buttons.push(Serenity.Exception.ReportHelper.createToolButton({
            // buttons.push(Serenity.Extensions.ReportHelper.createToolButton({
            //     buttons.push(GeniuzPOS.Common.ReportHelper.createToolButton({

            //     title: 'test',
            //     cssClass: 'export-pdf-button',
            //     reportKey: 'Purchase.ReportPurTaxLong',
            //     getParams: () => ({
            //         Shop: this.shop,
            //         Year:(Number(this.year)+543).toString(),
            //         Month: Q.tryFirst(QRreport.QMonthRow.getLookup().items, x => x.Months == this.mn).MonthName,
            //         Details:this.view.getRows()
            //        // OrderID: this.entityId
            //     })

            // }));



            // import { ExcelExportHelper, PdfExportHelper, ReportHelper } from "@serenity-is/extensions";
            // buttons.push(Serenity.Extensions.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit()
            // }));///ใช้ไม่ได้ภาษาไทยต่างด้าว




            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecPurTax/edit/117';
                        return false;
                    },
                }
            );


            return buttons;
        }
    }
}